<!--
 * @Descripttion: your project
 * @version: 1.0
 * @Author: zouyuping
 * @Date: 2023-03-06 16:54:48
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2024-02-27 16:53:01
-->
<template>
  <div>
    <ul class="blue_date_tab">
      <li
        v-for="(item, index) in dateTypeList"
        :key="index"
        @click="onClickDateType(item.type)"
        :class="item.type == nowDateType ? 'active' : ''"
      >
        {{ item.title }}
      </li>
    </ul>
    <div v-if="nowDateType == 5" class="date_con">
      <p>{{ nowStartDate || "选择开始日期" }}</p>
      <span>-</span>
      <p>{{ nowEndDate || "选择结束日期" }}</p>
    </div>
    <van-calendar
      v-model="showDatePicker"
      :min-date="minDate"
      :max-date="maxDate"
      type="range"
      color="var(--tc)"
      :default-date="defaultDate"
      @confirm="onConfirmDate"
    />
  </div>
</template>

<script>
import { dateFormat } from "@/utils/index";
export default {
  name: "DateTabCom",
  props: {},
  data() {
    return {
      nowDateType: 0,
      dateTypeList: [
        { title: "今日", type: 0 },
        { title: "本周", type: 1 },
        { title: "本月", type: 2 },
        { title: "本季", type: 3 },
        { title: "本年", type: 4 },
        { title: "自定义", type: 5 },
      ],
      showDatePicker: false,
      minDate: new Date(2010, 0, 1),
      maxDate: new Date(),
      nowStartDate: "",
      nowEndDate: "",
      defaultDate: [],
    };
  },
  created() {},
  mounted() {
    this.defaultDate = [this.getLastDate(1), new Date()];
  },
  methods: {
    getLastDate(n) {
      var currentDate = new Date();
      var date = new Date(currentDate.getTime() - n * 24 * 3600 * 1000);
      return date;
    },
    onClickDateType(name) {
      this.nowDateType = name;
      if (name == 5) {
        this.showDatePicker = true;
      } else {
      }
      this.$emit("change", this.nowDateType);
    },
    onConfirmDate(date) {
      const [start, end] = date;
      this.showDatePicker = false;
      console.log(date);
      this.nowStartDate = dateFormat(start);
      this.nowEndDate = dateFormat(end);
      this.$emit("changeDate", [this.nowStartDate, this.nowEndDate]);
      // this.date = `${this.formatDate(start)} - ${this.formatDate(end)}`;
    },
  },
};
</script>
<style scoped lang="scss">
.blue_date_tab {
  display: flex;
  margin: 20px 32px;

  border: 1px solid rgba(153, 153, 153, 0.6);
  border-radius: 50px;
  overflow: hidden;
  padding: 3px;
  li {
    flex: 1;
    height: 69px;
    line-height: 69px;
    text-align: center;
    // background: #fff;
    // border-radius: 20px;
    // margin-right: 10px;
    font-size: 25px;
    font-weight: bold;
    position: relative;
    border: 1px solid transparent;
    &:last-child {
      margin-right: 0;
    }
    &.active {
      // background: orange;
      // box-shadow: 0px 6px 17px 0px #5dcdfe;
      // color: #fff;
      border: 1px solid #f09e39;
      border-radius: 50px;
    }
    // &::after {
    //   content: "";
    //   width: 1px;
    //   height: 50px;
    //   position: absolute;
    //   right: 0;
    //   top: 18px;
    //   background: #ccc;
    // }
  }
}
.date_con {
  margin-top: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  span {
    margin: 0 20px;
  }
}
</style>
